if (!customElements.get('section-lta-hero-banner')) {
	customElements.define(
		'section-lta-hero-banner',
		class SectionLtaHeroBanner extends HTMLElement {
			constructor() {
				super();

				this.sectionId = this.dataset.id;

				this.setupCarousel();
			}

			// setupCarousel() {
			// 	if (!window.Swiper || !this.sectionId) return;

			// 	this.sectionSwiper = new window.Swiper(`#Carousel-${this.sectionId}`, {
			// 		loop: true,
			// 		grabCursor: false,
			// 		autoHeight: true,
			// 		lazy: true,
			// 		resistanceRatio: 0.7,
			// 		speed: 300,
			// 		threshold: 10,
			// 		slidesPerView: 1,
			// 		pagination: {
			// 			el: `#CarouselPagination-${this.sectionId}`,
			// 			clickable: true,
			// 		},
			// 		 navigation: {
			// 			nextEl: `#CarouselNext-${this.sectionId}`,
			// 			prevEl: `#CarouselPrev-${this.sectionId}`,
			// 		},
			// 	});
			// }

			setupCarousel() {
				if (!window.Swiper || !this.sectionId) return;

				const swiperEl = document.querySelector(`#Carousel-${this.sectionId}`);
				if (!swiperEl) return;

				const realSlides = swiperEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');

				if (realSlides.length <= 1) {
					swiperEl.classList.add("single-slide"); // 👈 add a flag class
					return; // skip Swiper init
				}

				this.sectionSwiper = new window.Swiper(`#Carousel-${this.sectionId}`, {
					loop: true,
					slidesPerView: 1,
					pagination: {
					el: `#CarouselPagination-${this.sectionId}`,
					clickable: true,
					},
					navigation: {
					nextEl: `#CarouselNext-${this.sectionId}`,
					prevEl: `#CarouselPrev-${this.sectionId}`,
					},
				});
			}

		}
	);
}

